// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"fcca05"};